import { ImportHistoryApi } from '../../../api/importHistoryApi';
import { Transaction } from '../../../interfaces/ImportHistory';
import { SnackbarParameters } from '../../../interfaces/Snackbar';
import withSnackbar from '../../../shared/components/withSnackbar';
import { SovosDialog, SovosDialogTitle, SovosDialogContent, SovosDialogActions, SovosButton } from 'mosaic-react';
import React, { useState } from 'react';

interface DeleteDialogProps {
	isDialogOpen: boolean;
	closeDialog: () => void;
	process: Transaction;
	snackbarData: (value: SnackbarParameters) => void;
}

const DeleteTemplateDialog: React.FC<DeleteDialogProps> = (props: DeleteDialogProps) => {
	const { isDialogOpen, closeDialog, process, snackbarData } = props;
	const [isDeleting, setIsDeleting] = useState<boolean>(false);

	const handleClose = (): void => {
		if (!isDeleting) {
			closeDialog();
		}
	};

	const handleDelete = (): void => {
		if (isDialogOpen) {
			setIsDeleting(true);
			ImportHistoryApi.removeProcess(process.processId)
				.then(() => {
					closeDialog();
					setIsDeleting(false);
					snackbarData({ message: 'Import removed', variant: 'confirmation', open: true });
				})
				.catch(error => {
					console.error('Error: ', error);
					setIsDeleting(false);
					closeDialog();
					let errorMessage =
						error.response && error.response.data && error.response.data.errors
							? error.response.data.errors[0].message
							: 'Unable to remove Import. Please try again later.';
					snackbarData({ message: errorMessage, variant: 'error', open: true });
				});
		}
	};

	return (
		<SovosDialog open={isDialogOpen} onClose={handleClose}>
			<SovosDialogTitle>Remove this Import?</SovosDialogTitle>
			<SovosDialogContent>
				<p>
					Transaction data contained in this import will no longer be available for filing. This action cannot be
					undone.
				</p>
			</SovosDialogContent>

			<SovosDialogActions>
				<SovosButton variant='text' onClick={handleClose} disabled={isDeleting}>
					Cancel
				</SovosButton>
				<SovosButton variant='text' color='error' onClick={handleDelete} disabled={isDeleting}>
					Remove Import
				</SovosButton>
			</SovosDialogActions>
		</SovosDialog>
	);
};

export default withSnackbar(DeleteTemplateDialog);
